export const educationData = [
  {
    id: 1,
    institution: "Masai School",
    course: `MERN stack Development`,
    startYear: "2021",
    endYear: "2021",
  },

  {
    id: 1,
    institution: "Pune University",
    course: `BE(Civil)`,
    startYear: "2014",
    endYear: "2018",
  },

  {
    id: 3,
    institution: "Kendriya Vidyalaya",
    course: "Schooling",
    startYear: "2003",
    endYear: "2014",
  },
];
